<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import { itemService } from "../../../../services/inventoryservice/item.service";
import { categoryService } from "../../../../services/inventoryservice/category.service";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Item Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Item",
      breadCrumb: {},
      itemData: null,
      categoryData: {},
      valueCategory: 0,
      valueCode: '',
      valueName: '',
      valueNameEn: '',
      valueQuantity: 0,
      valuePrice: 0,
      valueLastPrice: 0,
      valueLastSupplierPrice: 0,
      valueUnit: 'Piece'
      
    };
  },
  mounted() {

    this.loadingCategoryData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      itemService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.itemData = response;

          this.valueCode = this.itemData.data.code;
          this.valueName = this.itemData.data.name;
          this.valueNameEn = this.itemData.data.name_en;
          this.valueQuantity = this.itemData.data.qantity;
          this.valuePrice =  this.formatCurrency(this.itemData.data.price);
          this.valueLastPrice = this.formatCurrency(this.itemData.data.last_price);
          this.valueLastSupplierPrice = this.formatCurrency(this.itemData.data.last_supplier_price);
          this.valueCategory = this.itemData.data.category_id;
          this.valueUnit = this.itemData.data.unit;
          
        });
    },

    loadingCategoryData: function() {
      categoryService.getList('?page=0')
        .then(response => {

          // console.log(response.data);

          this.categoryData = response;

        });
    },
    

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "supplier-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;

      let item = {

        code: this.valueCode,
        name: this.valueName,
        name_en: this.valueNameEn == '' ? this.valueName : this.valueNameEn,
        qantity: this.valueQuantity,
        price: this.valuePrice,
        last_price: this.valueLastPrice,
        last_supplier_price: this.valueLastSupplierPrice,
        category_id: this.valueCategory,
        unit: this.valueUnit
      };

      // console.log(JSON.stringify(item));

      if(this.isAdd) {
        itemService.insert(item)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "item-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        itemService.update(this.$route.params.id, item)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "item-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.valueCode = '';
      this.valueName = '';
      this.valueNameEn = '';
      this.valueQuantity = 0;
      this.valuePrice = 0;
      this.valueLastPrice = 0;
      this.valueLastSupplierPrice = 0;
      this.valueCategory = 0;
      
    }, 

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('item.list'),
        href: '/additional/item',
      }, {
        text: $t('item.new'),
        active: true
      }]" :title="this.isAdd ? $t('item.new') : $t('item.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('item.list'),
        href: '/additional/item',
      }, this.breadCrumb]" :title="this.isAdd ? $t('item.new') : $t('item.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'item.code'"
                     /> 
                </div>
                <div class="col-md-6">
                  <Select 
                :text="'name'"
                    :id="'category_id'"
                    :text2="'name_en'"
                    :list="this.categoryData"
                    v-model="valueCategory"
                    :label="'category.text'"
                    :require="true"
                     /> 
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'item.name'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name-en'"
                    v-model="valueNameEn"
                    :label="'item.name-en'"  />
                </div>
              </div>

              <div class="row">
                <!-- <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'qantity'"
                    v-model="valueQuantity"
                    :require="true"
                    :label="'item.quantity'"  />
                </div> -->
                
                <div class="col-md-4">
                  
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'price'"
                    :last="'USD'"
                    v-model="valuePrice"
                    :label="'item.price'"  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'last_price'"
                    v-model="valueLastPrice"
                    :last="'USD'"
                    :disabled="true"
                    :label="'item.last-price'"  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'last_supplier_price'"
                    :last="'USD'"
                    :disabled="true"
                    v-model="valueLastSupplierPrice"
                    :label="'item.last-supplier-price'"  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'text'"
                    :id="'unit'"
                    v-model="valueUnit"
                    :label="'general.unit-name'"  />
                </div>
              </div>
              
          
              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>

      
    </b-form> 
  
  </Layout>
</template>